module.exports = __webpack_public_path__ + "static/puto-pao-cdc122fca3fef4953edbce278f64a97c.jpg";